const path = require('path')

module.exports = {
  env: process.env.NODE_ENV,
  path_base: path.resolve(__dirname, '../'),
  path_dist: 'dist',
  path_app: 'app',
  path_server: 'server',
  host: process.env.GATEWAY_HOST,
  universeHost: process.env.UNIVERSE_GATEWAY_HOST,
  wispHost: process.env.WISP_HOST,
  wispDev: process.env.WISP_HOST_DEV,
  wisp_public_url: process.env.WISP_PUBLIC_URL,
  invDeadlineDays: process.env.INV_DEADLINE_DAYS,
  invExpiredDays: process.env.INV_EXPIRED_DAYS,
  adminBdEmail: process.env.ADMIN_BD_EMAIL,
  adminCxEmail: process.env.ADMIN_CX_EMAIL,
  adminCollectionEmail: process.env.ADMIN_COLLECTION_EMAIL,
  adminFinanceEmail: process.env.ADMIN_FINANCE_EMAIL,
  adminNetworkEmail: process.env.ADMIN_NETWORK_EMAIL,
  adminOnboardingEmail: process.env.ADMIN_ONBOARDING_EMAIL,
  adminTrafficEmail: process.env.ADMIN_TRAFFIC_EMAIL,
  clientId: process.env.CLIENT_ID,
  clientSecret: process.env.CLIENT_SECRET,
  googleWebClientId: process.env.GOOGLE_WEB_CLIENT_ID,
  sentryDSN: process.env.SENTRY_DSN,
  shuttle_url: '/shuttle',
}
